import helper from './multi-account-helper.js';
const initialState = helper.createInitialState();
export default initialState;
